





























import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { format, parse, isValid } from "@/lib/time";
import { InputMaskOptions } from "@/modules/inputMask";
import { INPUT_PROPS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "BaseInputTime",
  components: { BaseInput, BaseIcon },
  props: {
    ...INPUT_PROPS,
    timeFormat: { type: String, default: "hh:mm a" },
  },
  setup(props, { emit }) {
    const inputElement = ref<HTMLInputElement>();
    const support = ref(true);

    const inputFormat = computed(() => {
      return props.timeFormat
        .split("")
        .map(c => {
          if (c === "m") return "M";
          if (c === "a") return "TT";
          return c;
        })
        .join("");
    });

    const placeHolder = computed(() => inputFormat.value.toUpperCase().replace("TT", "AM"));

    const opts = computed<InputMaskOptions>(() => ({
      showMaskOnHover: false,
      showMaskOnFocus: false,
      alias: "datetime",
      inputFormat: inputFormat.value,
      placeholder: placeHolder.value,
    }));

    const currentValue = computed(() => {
      try {
        const date = parse(props.value ?? "", props.timeFormat, new Date());
        if (!isValid(date)) {
          return format(parse(props.value ?? "", "HH:mm", new Date()), props.timeFormat);
        }
      } catch (e) {}
      return props.value;
    });

    const onInput = (v: string) => {
      const date = parse(v, props.timeFormat, new Date());
      if (isValid(date)) {
        emit("input", format(date, "HH:mm"));
      } else {
        emit("input", v);
      }
    };

    onMounted(() => {
      support.value = inputElement.value?.type === "time";
    });

    return {
      support,
      currentValue,
      opts,
      placeHolder,
      inputElement,
      onInput,
    };
  },
});
